import { ArrowLeft } from 'lucide-react';
import { match } from 'ts-pattern';

import { Button } from '@nesso/ui/primitives/button';

import type { Session } from '@/entities/session';
import {
    formatDurationLabel,
    formatShortDate,
    formatTime,
    formatTimeRange,
} from '@/shared/lib/time-utils';

type Props = {
    session: Session;
    onBack: () => void;
};

export function SessionDetailsHeaderInfo({ session, onBack }: Props) {
    const clientName = session.clients[0]?.name ?? 'Unknown Client';
    const date = formatShortDate(session.date);
    const startTime = formatTime(session.date);
    const endDate = new Date(new Date(session.date).getTime() + session.duration * 60_000);
    const timeRange = formatTimeRange(session.date, endDate);
    const duration = formatDurationLabel(session.duration);

    const timeInfo = match(session.inputMethod)
        .with('DICTATION', () => `Dictated on ${date}, ${startTime}`)
        .with('LIVE_RECORDING', () => `${date}, ${timeRange} (${duration})`)
        .otherwise(() => `${date}, ${startTime}`);

    return (
        <div className="flex items-center gap-2">
            <Button
                variant="ghost"
                size="icon"
                className="size-10 shrink-0"
                onClick={onBack}
                aria-label="Go back"
            >
                <ArrowLeft className="h-4 w-6" />
            </Button>
            <div className="flex flex-col">
                <h2 className="text-lg font-bold leading-7 truncate max-w-xs sm:max-w-sm">
                    {clientName}
                </h2>
                <p className="text-sm sm:text-base font-medium leading-5 sm:leading-6">
                    {timeInfo}
                </p>
            </div>
        </div>
    );
}
